import React from "react";

function BackArrow({ size, color }: { size?: number; color?: string }) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <rect width="25" height="25" fill="url(#pattern0_325_132)"/>
    <defs>
    <pattern id="pattern0_325_132" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use xlinkHref="#image0_325_132" transform="scale(0.0111111)"/>
    </pattern>
    <image id="image0_325_132" width="90" height="90" preserveAspectRatio="none" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABX0lEQVR4nO3avUoDQRiF4S8W/oBXcq5AJkXavStLLUTS2mg3A1taLN6RlRBUsFzZ7WxSBDOjZ98HtgtkeDlMUmwEAAAAAAAA/pduOItU7mKd3yKVz0j5Ia76i9bHMoych1iX8cczxcaRI89Pfv+tr1m2bl/kOfSu9REXELlMz33rY/pHTnmYP4cDqT+NVJ73Lzm/xObp/NCvgIh8fEQmsgdxXRDZglgykS2IJRPZglgykS2IJRPZglgykS2IJRPZglgykS2IJRPZglgykS10vNxSR8q3vEFUJ/QrbxAR2kjKN1wdNXT8GNYj/kMT25JYNrEtiWUT25JYNrEtiWUT25JYNrEtiWUT25JYNrEtiWUT25JYNrEtiWUT25JYdj3EroiXdP5c7G3NIy03dsofEeOq9TH9Y6fyFXF90vqIC4idH1sfzTX2dr4upiVPkTf9ZetjGRtX3MsAAAAAAISzb+l6d+V82rx7AAAAAElFTkSuQmCC"/>
    </defs>
    </svg>
  );
}




export default BackArrow;
